var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27273 2.04545C7.67439 2.04545 8 2.41175 8 2.86364L8 8.18182C8 8.6337 7.67439 9 7.27272 9L2.54545 9C2.14378 9 1.81818 8.6337 1.81818 8.18182L1.81818 2.86364C1.81818 2.41175 2.14378 2.04545 2.54545 2.04545L7.27273 2.04545ZM7.27273 8.18182L7.27273 2.86364L2.54545 2.86364L2.54545 8.18182L7.27273 8.18182ZM5.45455 -1.11265e-07C5.85622 -9.37077e-08 6.18182 0.366316 6.18182 0.818182L6.18182 1.22727C6.18182 1.45321 6.01902 1.63636 5.81818 1.63636C5.61735 1.63636 5.45455 1.45321 5.45455 1.22727L5.45455 0.818182L0.727272 0.818181L0.727272 6.13636L1.09091 6.13636C1.29174 6.13636 1.45454 6.31951 1.45454 6.54545C1.45454 6.77139 1.29174 6.95455 1.09091 6.95455L0.727272 6.95455C0.325599 6.95455 -2.87981e-07 6.58825 -2.68229e-07 6.13636L-3.57639e-08 0.818181C-1.6012e-08 0.366312 0.3256 -3.35459e-07 0.727273 -3.17901e-07L5.45455 -1.11265e-07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDup);
export default __webpack_public_path__ + "static/media/dup.33fec57414d7003893e5ee42c6fd03c1.svg";
export { ForwardRef as ReactComponent };